export default {
  section: {
    marginBottom: 20,
  },
  copyButton: {
    float: 'right',
    marginRight: 30,
    backgroundColor: '#f0405d',
    color: 'white',
    fontSize: 12,
    verticalAlign: 'baseline',
    border: 'none',
    padding: '4px 14px',
  },
  table: {
    '@global': {
      'td:nth-child(1)': {
        textAlign: 'left',
      },
      'td:nth-child(1)>span': {
        maxWidth: 200,
        display: 'inline-block',
        whiteSpace: 'normal',
      },
      'th:nth-child(1)': {
        textAlign: 'left',
        paddingLeft: 28,
        width: '20% !important',
      },
      'tfoot th': {
        whiteSpace: 'nowrap',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsCityPlan/styles.js